import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { OtpGuard } from './core/guards/auth/otp.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'inicio',
    pathMatch: 'full',
  },
  {
    path: 'inicio',
    loadChildren: () => import('./modules/components/home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'auth',
    loadChildren: () => import('./modules/components/authentication/authentication.module').then(m => m.AuthenticationModule)
  },
  {
    path: 'policy',
    loadChildren: () => import('./modules/components/policy/policy.module').then(m => m.PolicyModule),
    canActivate: [OtpGuard]
  },
  {
    path: '**',
    redirectTo: 'inicio'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(
    routes,
    {
      preloadingStrategy: PreloadAllModules,
      useHash: false
    }
  )
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
